import type { MailServerDraft, MailServerSettings } from './types'

/** The owner's list of allowed recipient domains, as typed: commas or spaces between. */
export function domainsFrom(text: string): string[] {
  return text.split(/[,\s]+/).map((d) => d.trim()).filter(Boolean)
}

/**
 * Whether the Mail server form holds something not yet saved. The test letter is
 * sent with the saved settings, so while this is true the Send button would test
 * a server other than the one on the screen, and stays shut.
 */
export function mailFormChanged(saved: MailServerSettings | null, draft: MailServerDraft, domains: string, password: string): boolean {
  if (!saved || password !== '') return true
  const now = { ...draft, allowedDomains: domainsFrom(domains) }
  const was: MailServerDraft = {
    host: saved.host, port: saved.port, security: saved.security, username: saved.username ?? '',
    fromAddress: saved.fromAddress, caPem: saved.caPem ?? '', allowedDomains: saved.allowedDomains ?? [], enabled: saved.enabled,
  }
  return (Object.keys(was) as (keyof MailServerDraft)[]).some((k) => JSON.stringify(now[k]) !== JSON.stringify(was[k]))
}
